//import { polyfill } from "seamless-scroll-polyfill";

//polyfill();

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();


export const initStory = function () {

  
  document.querySelectorAll('.story-nav-lien').forEach(item => {
    item.addEventListener('click', event => {
      scroll(event);
    })
  })

  initIntroVeltystory()
  positionLogo()
  //window.onresize = positionLogo()




    const slider = document.querySelector('.bloc-veltystory');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
     // console.log(walk);
    });



}


const scroll = function (e) {
  const annee = e.currentTarget.dataset.annee
  const pos = document.querySelector('.story-position-annee-'+annee).getBoundingClientRect();
  const posGlobale = document.querySelector('.bloc-veltystory').getBoundingClientRect(); 
  document.querySelector('.bloc-veltystory').scrollBy({ left: pos.x - 150, top: 0, behavior: 'smooth' })

  //document.querySelector('.bloc-veltystory').scrollLeft += pos.x - 150;

}


const threshold = .1
let options = {
  root: null,
  rootMargin: '-100px',
  threshold
}


const initIntroVeltystory = function () {
  
  if (document.querySelector('.bloc-veltystory-intro')) {
    const handleIntersect = function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > threshold) {
          entry.target.classList.remove('bloc-veltystory-intro')
          observer.unobserve(entry.target)
        }
      })
    }
    //document.querySelector('.bloc-veltystory').classList.add('reveal-loaded')
  
    const observer = new IntersectionObserver(handleIntersect, options)
    const target = document.querySelector('.bloc-veltystory-intro')
    observer.observe(target)
    
  }
  
}

const positionLogo = function () {
    
    const posLogo = document.querySelector('.story-logo').getBoundingClientRect();
    const posStory = document.querySelector('.story-logo-story').getBoundingClientRect();
    const posHaut  = document.querySelector('.story-haut').getBoundingClientRect();
    let largeur = window.innerWidth
    if (largeur > 1600) largeur = 1600

    const logoLeft = (largeur/2) - (posLogo.width/2) - posHaut.left
    const storyLeft = (largeur/2) - (posStory.width/2) - posHaut.left
  //console.log(largeur,logoLeft,storyLeft)
    document.querySelector('.story-logo').style.left = logoLeft +'px'
    document.querySelector('.story-logo-story').style.left = storyLeft +'px'
}